import { Sheet } from "./Sheet";
import { ExternalButton } from "./Button";
import { PHANTOM_INSTALL_URL } from "../wallets/phantom";
import { METAMASK_INSTALL_URL } from "../wallets/metamask";

type Wallet = "phantom" | "metamask" | null;

const COPY = {
  phantom: {
    title: "Phantom not detected",
    body: "Phantom proves you held $INDEXSY on Solana at the snapshot. Install it, reload this page, then connect.",
    cta: "Get Phantom",
    href: PHANTOM_INSTALL_URL,
  },
  metamask: {
    title: "MetaMask not detected",
    body: "MetaMask holds the address that will receive $TISM on Robinhood Chain. Install it, reload this page, then connect.",
    cta: "Get MetaMask",
    href: METAMASK_INSTALL_URL,
  },
} as const;

/** Shown as a bottom sheet on phones when a wallet is not installed. */
export function WalletMissingSheet({ wallet, onClose }: { wallet: Wallet; onClose: () => void }) {
  const copy = wallet ? COPY[wallet] : null;
  return (
    <Sheet open={copy !== null} title={copy?.title ?? ""} onClose={onClose}>
      {copy ? (
        <div className="stack stack-4">
          <p className="body">{copy.body}</p>
          <p className="tiny">
            Nobody from this project will ever message you first or ask for a seed phrase.
          </p>
          <ExternalButton href={copy.href} block>
            {copy.cta}
          </ExternalButton>
        </div>
      ) : null}
    </Sheet>
  );
}
